import { RootState } from '@reducers';

export const selectBilling = (state: RootState) => state.userDashboardRouteReducer.billingReducer;
